// import { Component, OnInit, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { BaseModalContainer
  , ModalContainerService
  , ModalService
  , UserService
  , ModelDataService } from 'yt-ng-framework';
import { BracniStatus } from './bracni-status';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-bracni-status',
  templateUrl: './bracni-status.component.html'
})
export class BracniStatusComponent
 extends BaseModalContainer<BracniStatus>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<BracniStatus>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService,
    protected modelDataService: ModelDataService
  ) {
    super(modalContainerService
      , activatedRoute
      , modalService
      , userService
      , modelDataService);
  }

  // @ViewChild("List") list:DefaultListModalComponent<BracniStatus>

  ngOnInit() {
  }

}
